import useGlobalParameter from '../../../utils/customHook/useGlobalParameter'

const RETURN_PERIOD_SETTING = 'OBSERVATOIRE_PERIODES_DE_RETOUR'
const WATER_STRESS_SETTING = 'OBSERVATOIRE_STRESS_HYDRIQUE'

const settingParser = setting => `${setting}`.toLowerCase() === 'true' || setting === '1'

const useReturnPeriodEnabled = () => useGlobalParameter(RETURN_PERIOD_SETTING, settingParser)

const useWaterStressEnabled = () => {
    const returnPeriodEnabled = useGlobalParameter(RETURN_PERIOD_SETTING, settingParser)
    const waterStressSetting = useGlobalParameter(WATER_STRESS_SETTING, settingParser)

    return returnPeriodEnabled && waterStressSetting
}

export { RETURN_PERIOD_SETTING, WATER_STRESS_SETTING, useReturnPeriodEnabled, useWaterStressEnabled }
